import { HttpErrorResponse } from '@angular/common/http';

import { EmptyObject } from 'src/app/shared/services/generic-bloc.service';
import { CurrentUser } from '../../models/account.model';
import { Token } from '../../models/token.model';

export enum LoginEvent {
  fetchToken,
  fetchUserInfo,
  loadBaseDataError,
  recoverPassword,
}

export type LoginEventPayloads = {
  [LoginEvent.fetchToken]: { username: string; password: string };
  [LoginEvent.fetchUserInfo]: EmptyObject;
  [LoginEvent.loadBaseDataError]: EmptyObject;
  [LoginEvent.recoverPassword]: { username: string };
};

export enum LoginAction {
  tokenFetched,
  tokenFetchedFailed,
  userInfoFetched,
  userInfoFetchedFailed,
  loadBaseDataError,
  passwordRecovered,
  passwordRecoveredFailed,
}

export type LoginActionPayloads = {
  [LoginAction.tokenFetched]: { token: Token };
  [LoginAction.tokenFetchedFailed]: { httpError: HttpErrorResponse };
  [LoginAction.userInfoFetched]: { currentUser: CurrentUser };
  [LoginAction.userInfoFetchedFailed]: { httpError: HttpErrorResponse };
  [LoginAction.loadBaseDataError]: EmptyObject;
  [LoginAction.passwordRecovered]: EmptyObject;
  [LoginAction.passwordRecoveredFailed]: { error: HttpErrorResponse };
};
